export default function NotFound (): React.ReactNode {
  return (
    <div>
      <h1 className='my-8 text-3xl font-bold'>Not found</h1>
      <p>This page does not exist.</p>
    </div>
  )
}
